import styled from "styled-components/macro";

import { useRecurringGifts } from "CrossFeatureComponents/UserRecurringGifts/RecurringGiftsContext";
import RecurringGiftsList from "CrossFeatureComponents/UserRecurringGifts/RecurringGiftsList";
import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

import FnrIcon from "UI/FnrIcon";

import ListIsEmpty from "./ListIsEmpty";

export default function RecurringGiftsScreen() {
  const { state: pageState } = useManageMyGivingPage();
  const { state: recurringState } = useRecurringGifts();
  const listStatus = recurringState.recurringGiftsListStatus;
  const listIsEmpty =
    listStatus === "success" && recurringState.recurringGifts.length < 1;

  const firstGiveableFund = pageState.funds.find(
    (fund) => fund.allowRecurringGifts
  );

  const title = firstGiveableFund
    ? "Your household has not set up any recurring gifts yet. We humbly invite you to support our mission by setting up a recurring gift."
    : "Your household does not have any recurring gifts currently set up.";

  if (listIsEmpty) {
    return (
      <Wrapper>
        <ListIsEmpty
          title={title}
          icon={<FnrIcon fad fa-repeat />}
          showButton={Boolean(firstGiveableFund?.ID)}
          linkTo={`/give/${firstGiveableFund?.ID}?recurringSchedule="monthly"`}
          buttonText={`Set up a recurring gift to the ${firstGiveableFund?.description} now`}
          messageIfNoButton="No funds are configured to accept recurring gifts."
        />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <RecurringGiftsList />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding: 0 20px 20px 20px;
`;
